import React, { useEffect, useState } from 'react';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import Footer from '../footer';
import { Link } from 'react-router-dom';

export default function AddNewPayroll() {
    const [form, setForm] = useState({
        staffName: '',
        designation: '',
        salaryMonth: '',
        basic: '',
        hra: '',
        other: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Calculate total salary
        const total = Number(form.basic || 0) + Number(form.hra || 0) + Number(form.other || 0);

        // Prepare payroll object
        const newPayroll = {
            ...form,
            total,
        };

        alert("New Payroll Added:\n" + JSON.stringify(newPayroll, null, 2));

        // TODO: Send newPayroll to backend or update state/store

        // Reset form
        setForm({
            staffName: '',
            designation: '',
            salaryMonth: '',
            basic: '',
            hra: '',
            other: '',
        });

        // TODO: Redirect back to Payroll History page
    };
    useEffect(() => {
        const basic = parseFloat(form.basic || 0);
        const hra = parseFloat(form.hra || 0);
        const other = parseFloat(form.other || 0);
        const deductions = parseFloat(form.deductions || 0);
        const netPay = basic + hra + other - deductions;

        setForm(prev => ({ ...prev, netPay: netPay.toFixed(2) }));
    }, [form.basic, form.hra, form.other, form.deductions]);

    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid py-4">
                                <div className="card shadow p-4 border-0">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h3 className="text-primary fw-bold">Add New Payroll</h3>
                                        <Link to="/payroll" className="btn btn-outline-danger">Go Back</Link>
                                    </div>

                                 <form onSubmit={handleSubmit} className="p-4">

    {/* Staff Information */}
    <h5 className="fw-bold text-primary mb-3"> Staff Information</h5>
    <div className="row g-3 mb-4">
        <div className="col-md-6">
            <label className="form-label">Staff Name <span className="text-danger">*</span></label>
            <input
                type="text"
                className="form-control input-capitalize"
                name="staffName"
                value={form.staffName}
                onChange={handleChange}
                placeholder="Enter staff name"
                required
            />
        </div>

        <div className="col-md-6">
            <label className="form-label">Designation <span className="text-danger">*</span></label>
            <input
                type="text"
                className="form-control input-uppercase"
                name="designation"
                value={form.designation}
                onChange={handleChange}
                placeholder="Enter designation"
                required
            />
        </div>
    </div>

    <hr />

    {/* Payroll Information */}
    <h5 className="fw-bold text-primary mb-3"> Payroll Details</h5>
    <div className="row g-3 mb-3">
        <div className="col-md-4">
            <label className="form-label">Salary Month <span className="text-danger">*</span></label>
            <input
                type="month"
                className="form-control"
                name="salaryMonth"
                value={form.salaryMonth}
                onChange={handleChange}
                required
            />
        </div>

        <div className="col-md-4">
            <label className="form-label">Basic Salary <span className="text-danger">*</span></label>
            <input
                type="number"
                className="form-control"
                name="basic"
                value={form.basic}
                onChange={handleChange}
                min="0"
                placeholder="0"
                required
            />
        </div>

        <div className="col-md-4">
            <label className="form-label">HRA</label>
            <input
                type="number"
                className="form-control"
                name="hra"
                value={form.hra}
                onChange={handleChange}
                min="0"
                placeholder="0"
            />
        </div>
    </div>

    <div className="row g-3 mb-3">
        <div className="col-md-4">
            <label className="form-label">Other Allowances</label>
            <input
                type="number"
                className="form-control"
                name="other"
                value={form.other}
                onChange={handleChange}
                min="0"
                placeholder="0"
            />
        </div>

        <div className="col-md-4">
            <label className="form-label">Deductions</label>
            <input
                type="number"
                className="form-control"
                name="deductions"
                value={form.deductions}
                onChange={handleChange}
                min="0"
                placeholder="0"
            />
        </div>

        <div className="col-md-4">
            <label className="form-label">Net Pay</label>
            <input
                type="number"
                className="form-control"
                name="netPay"
                value={form.netPay}
                readOnly
                placeholder="Auto Calculated"
            />
        </div>
    </div>

    <div className="text-end mt-4">
        <button type="submit" className="btn btn-primary px-4 py-2">
             Submit Payroll
        </button>
    </div>
</form>

                                </div>

                                <Footer />
                                <div className="content-backdrop fade"></div>
                            </div>
                        </div>

                        <div className="layout-overlay layout-menu-toggle"></div>
                        <div className="drag-target"></div>
                    </div>
                </div>
            </div>
        </>
    );
}
